<template>
  <a-tabs class="tabs" v-model="activeKey"  >
    <a-tab-pane  key="1" tab="测评结果总评价" >
      <project-result-config2-list></project-result-config2-list>
    </a-tab-pane>
    <a-tab-pane  key="2" tab="测评结果分类评价" >
      <project-result-config-list ></project-result-config-list>

    </a-tab-pane>
    <a-tab-pane  key="3" tab="测评结果明细评价" >
      <project-result-config-item-list ></project-result-config-item-list>

    </a-tab-pane>
  </a-tabs>
</template>

<script>
  import ProjectResultConfigList from './resultConfig/ProjectResultConfigList'
  import ProjectResultConfigItemList from './resultConfig/ProjectResultConfigItemList'
  import ProjectResultConfig2List from './resultConfig/ProjectResultConfig2List'
  export default {
    name: 'ResultConfig',
    components: { ProjectResultConfig2List, ProjectResultConfigItemList, ProjectResultConfigList },
    data(){
      return {
        resultList:[],
        activeKey:"1"
      }
    },
    mounted(){

    },
    methods:{
    }
  }
</script>

<style scoped>

</style>